export default "__VITE_ASSET__h3NSFLnt__"